import api from '@/core/apiclient'
import { actionTypes, mutationTypes } from '@/core/constants'

export default {
    async [actionTypes.AJUSTE.BUSCAR_AJUSTE_POR_ID]({ commit }, id) {
        const { data } = await api.ajuste.buscarPorId(id)
        commit(mutationTypes.AJUSTE.SET_AJUSTE, data)
        return data
    },

    async [actionTypes.AJUSTE.BUSCAR_TODOS_AJUSTES]({ state }) {
        const { filtros, paginacao } = state.todosAjustes
        const { data } = await api.ajuste.buscarTodos(filtros, paginacao)
        return data
    },

    async [actionTypes.AJUSTE.CADASTRAR_NOVO_AJUSTE]({ commit }, ajuste) {
        const { data } = await api.ajuste.salvar(ajuste)
        commit(mutationTypes.LOKI.ENABLE_AUTO_SAVING)
        commit(mutationTypes.AJUSTE.SET_AJUSTE, data)
        commit(mutationTypes.LOKI.DISABLE_AUTO_SAVING)
    },

    async [actionTypes.AJUSTE.BUSCAR_AJUSTE_POR_PATRIMONIO](context,dados) {
        const { data } = await api.ajuste.buscarAjustePorPatrimonio(dados)
        return data
    }
}
